// @generated by protoc-gen-es v1.0.0 with parameter "rewrite_imports=./google/api/**/*_pb.js:@buf/googleapis_googleapis.bufbuild_es,rewrite_imports=./gogoproto/**/*_pb.js:@buf/cosmos_gogo-proto.bufbuild_es,rewrite_imports=./cosmos_proto/**/*_pb.js:@buf/cosmos_cosmos-proto.bufbuild_es"
// @generated from file tendermint/version/types.proto (package tendermint.version, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * App includes the protocol and software version for the application.
 * This information is included in ResponseInfo. The App.Protocol can be
 * updated in ResponseEndBlock.
 *
 * @generated from message tendermint.version.App
 */
export const App = proto3.makeMessageType(
  "tendermint.version.App",
  () => [
    { no: 1, name: "protocol", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "software", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Consensus captures the consensus rules for processing a block in the blockchain,
 * including all blockchain data structures and the rules of the application's
 * state transition machine.
 *
 * @generated from message tendermint.version.Consensus
 */
export const Consensus = proto3.makeMessageType(
  "tendermint.version.Consensus",
  () => [
    { no: 1, name: "block", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "app", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

